export const data_applicantPending = [
  {
    sno: 1,
    applicantName: "Abhijeet Suresh Sharma",
    caseId: 349570,
    caseSpoc: "Shreyesth Kohli",
    employeeId: 6323073,
    emailId: "abhi.sharma@gmail.com",
    daysElapsed: "12 Days",
    phoneNo: "+91 9876543210",
    invitationDate: "04-05-2026",
    status: "Pending Login",
    inviteExpiryDate: "19-05-2026",
    action: "Modify Invite",
    viewLog: true,
  },
  {
    sno: 2,
    applicantName: "Priya Mehta",
    caseId: 349571,
    caseSpoc: "Rohan Verma",
    employeeId: 6323074,
    emailId: "priya.mehta@yahoo.com",
    daysElapsed: "8 Days",
    phoneNo: "+91 9123456780",
    invitationDate: "08-05-2026",
    status: "Logged In",
    inviteExpiryDate: "23-05-2026",
    action: "Modify Invite",
    viewLog: true,
  },
  {
    sno: 3,
    applicantName: "Karan Malhotra",
    caseId: 349572,
    caseSpoc: "Neha Kapoor",
    employeeId: 6323075,
    emailId: "karan.m@gmail.com",
    daysElapsed: "5 Days",
    phoneNo: "+91 9988776655",
    invitationDate: "11-05-2026",
    status: "Pending Login",
    inviteExpiryDate: "26-05-2026",
    action: "Modify Invite",
    viewLog: true,
  },
  {
    sno: 4,
    applicantName: "Sneha Iyer",
    caseId: 349573,
    caseSpoc: "Amit Chauhan",
    employeeId: 6323076,
    emailId: "sneha.iyer@outlook.com",
    daysElapsed: "15 Days",
    phoneNo: "+91 9090909090",
    invitationDate: "01-05-2026",
    status: "Invite Expired",
    inviteExpiryDate: "16-05-2026",
    action: "Resend Invite",
    viewLog: true,
  },
  {
    sno: 5,
    applicantName: "Rahul Bansal",
    caseId: 349574,
    caseSpoc: "Vikram Joshi",
    employeeId: 6323077,
    emailId: "rahul.bansal@gmail.com",
    daysElapsed: "2 Days",
    phoneNo: "+91 9811122233",
    invitationDate: "14-05-2026",
    status: "Pending Login",
    inviteExpiryDate: "29-05-2026",
    action: "Modify Invite",
    viewLog: true,
  },
  {
    sno: 6,
    applicantName: "Meera Nair",
    caseId: 349575,
    caseSpoc: "Pooja Singh",
    employeeId: 6323078,
    emailId: "meera.nair@gmail.com",
    daysElapsed: "7 Days",
    phone: "+91 9871234567",
    invitationDate: "09-05-2026",
    status: "Logged In",
    inviteExpiryDate: "24-05-2026",
    action: "View Details",
    viewLog: true,
  },
];

export const data_WIP = [
  {
    key: "1",
    sno: 1,
    applicant_name: "Ranjana Jena",
    case_id: "357238",
    case_spoc: "Shubham Pal",
    employee_id: "CAND-1054000",
    case_received_date: "22-04-2026",
    sla_start_date: "23-04-2026",
    due_date: "08-05-2026",
    total_checks: 6,
    work_in_progress: 6,
    completed: 0,
    stop: 0,
    insuff_expire: "–",
    actions: "",
  },
  {
    key: "2",
    sno: 2,
    applicant_name: "Krishna Tiwari",
    case_id: "366636",
    case_spoc: "Govinda Bika",
    employee_id: "6339216",
    case_received_date: "22-04-2026",
    sla_start_date: "23-04-2026",
    due_date: "08-05-2026",
    total_checks: 6,
    work_in_progress: 5,
    completed: 1,
    stop: 0,
    insuff_expire: "–",
    actions: "",
  },
  {
    key: "3",
    sno: 3,
    applicant_name: "Vatsal Panthri",
    case_id: "366635",
    case_spoc: "Govinda Bika",
    employee_id: "6339215",
    case_received_date: "22-04-2026",
    sla_start_date: "23-04-2026",
    due_date: "08-05-2026",
    total_checks: 5,
    work_in_progress: 4,
    completed: 1,
    stop: 0,
    insuff_expire: "–",
    actions: "",
  },
];

export const data_candidatePendency = [
  {
    sno: 1,
    applicant_name: "Aman Choubey",
    case_id: 374538,
    case_spoc: "Govinda Bika",
    employee_id: 6345822,
    case_received_date: "29-04-2026",
    sla_start_date: "29-04-2026",
    due_date: "14-05-2026",
    total_checks: 5,
    work_in_progress: null,
    completed: 2,
    stop: null,
    insuffExpire: null,
  },
  {
    sno: 2,
    applicant_name: "Deanshu Joshi",
    case_id: 368483,
    case_spoc: "Govinda Bika",
    employee_id: 6340440,
    case_received_date: "25-04-2026",
    sla_start_date: "27-04-2026",
    due_date: "12-05-2026",
    total_checks: 4,
    work_in_progress: null,
    completed: 1,
    stop: null,
    insuffExpire: null,
  },
  {
    sno: 3,
    applicant_name: "Ravarna Jena",
    case_id: 357238,
    case_spoc: "Shubham Pal",
    employee_id: "CAND-1054000",
    case_received_date: "22-04-2026",
    sla_start_date: "23-04-2026",
    due_date: "25-05-2026",
    total_checks: 6,
    work_in_progress: null,
    completed: 5,
    stop: null,
    insuffExpire: null,
  },
  {
    sno: 4,
    applicant_name: "Sudhanshu",
    case_id: 366637,
    case_spoc: "Govinda Bika",
    employee_id: 6339262,
    case_received_date: "27-04-2026",
    sla_start_date: "28-04-2026",
    due_date: "18-05-2026",
    total_checks: 6,
    work_in_progress: null,
    completed: 3,
    stop: null,
    insuffExpire: null,
  },
  {
    sno: 5,
    applicant_name: "Harshika",
    case_id: 351675,
    case_spoc: "Govinda Bika",
    employee_id: 6316451,
    case_received_date: "23-04-2026",
    sla_start_date: "24-04-2026",
    due_date: "11-05-2026",
    total_checks: 6,
    work_in_progress: null,
    completed: 5,
    stop: null,
    insuffExpire: null,
  },
  {
    sno: 6,
    applicant_name: "Yashika Arora",
    case_id: 364532,
    case_spoc: "Shreyesth Kohli",
    employee_id: 6337657,
    case_received_date: "21-04-2026",
    sla_start_date: "21-04-2026",
    due_date: "06-05-2026",
    total_checks: 6,
    work_in_progress: null,
    completed: 3,
    stop: null,
    insuffExpire: null,
  },
  {
    sno: 7,
    applicant_name: "Shiv Verma",
    case_id: 364524,
    case_spoc: "Shreyesth Kohli",
    employee_id: 6338564,
    case_received_date: "25-04-2026",
    sla_start_date: "27-04-2026",
    due_date: "12-05-2026",
    total_checks: 5,
    work_in_progress: null,
    completed: 2,
    stop: null,
    insuffExpire: null,
  },
  {
    sno: 8,
    applicant_name: "Akshu Sethi",
    case_id: 364517,
    case_spoc: "Shreyesth Kohli",
    employee_id: 6337910,
    case_received_date: "27-04-2026",
    sla_start_date: "28-04-2026",
    due_date: "13-05-2026",
    total_checks: 5,
    work_in_progress: null,
    completed: 2,
    stop: null,
    insuffExpire: null,
  },
  {
    sno: 9,
    applicant_name: "Umi Shelly",
    case_id: 363976,
    case_spoc: "Shreyesth Kohli",
    employee_id: null,
    case_received_date: "22-04-2026",
    sla_start_date: "25-04-2026",
    due_date: "10-05-2026",
    total_checks: 10,
    work_in_progress: null,
    completed: 3,
    stop: 5,
    insuffExpire: null,
  },
  {
    sno: 10,
    applicant_name: "Dinesh Solanke",
    case_id: 361407,
    case_spoc: "Shreyesth Kohli",
    employee_id: null,
    case_received_date: "18-04-2026",
    sla_start_date: "21-04-2026",
    due_date: "06-05-2026",
    total_checks: 6,
    work_in_progress: null,
    completed: 3,
    stop: null,
    insuffExpire: null,
  },
];
